export default "__VITE_ASSET__Cywk8jac__"